import { useLayoutEffect } from "react"
import { useLocation } from "react-router-dom"
import { recordRouterPathnameFromLocation } from "~Shared/router/routerPathnameChain.sync"

/** Mirrors pathname transitions from `useLocation` for browser-back safety checks (no Web Storage). */
export const RouterPathnameChainRecorder = () => {
    const { pathname } = useLocation()

    useLayoutEffect(() => {
        recordRouterPathnameFromLocation(pathname)
    }, [pathname])

    return null
}
